<pdq-tabs-group variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'" class="custom-upsell-tabs">
  @for (tab of tabs; track tab.value) {
    <pdq-tab
      [label]="tab.label"
      [value]="tab.value"
      [active]="tab.value === activeTab"
      [showNewBadge]="tab.showNewBadge"></pdq-tab>
  }
</pdq-tabs-group>

<div class="custom-upsell-form-container">
  @switch (activeTab) {
    @case (CustomUpsellFormTab.SETTINGS) {
      <custom-upsell-form-settings
        [formGroup]="formGroup"
        [restrictionsRules]="restrictionsRules"
        [entities]="entities"
        [shopCurrencySymbol]="shopCurrencySymbol"
        [shop$]="shop$"
        [shopService]="shopService"
        [loadedExtension]="loadedExtension"
        [updateRequired]="updateRequired"
        [updateAppUrl]="updateAppUrl"
        [productImageBase64]="productImageBase64"
        [customUpsellConfig]="customUpsellConfig"
        [upsellRateTypeConfig]="upsellRateTypeConfig"
        [applyDiscountToOptions]="applyDiscountToOptions"
        [PlacementMode]="PlacementMode"
        [camelCaseToTitleCase]="camelCaseToTitleCase"
        [formArrayFieldName]="formArrayFieldName"
        (applyDiscountToChange)="handleApplyDiscountToChange($event)"
        (productImageChange)="handleProductImageChange($event)"
        (clearImageEvent)="handleClearImage()"
        (updateAppPermissions)="handleUpdateAppPermissions()"></custom-upsell-form-settings>
    }
    @case (CustomUpsellFormTab.TIMER) {
      <custom-upsell-form-timer
        [timerConfiguration]="timerConfiguration"
        (timerConfigurationChange)="handleTimerConfigurationChange()"></custom-upsell-form-timer>
    }
  }
</div>
